var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"about"},[_c('h1',[_vm._v("About")]),_c('h1',[_vm._v(_vm._s(_vm.$store.competition.name))]),_c('section',{domProps:{"innerHTML":_vm._s(_vm.markdown(_vm.$store.competition.about))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }